import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Form } from "react-bootstrap";
import { AuthService, EventApplicationService } from "../../../../services";
import { CaterApplicationFormModel } from "../../../../components/Model/CaterApplicationFormModel";
import { handleConsoleError } from "../../../../utils/common-methods";
import { toast } from "react-toastify";

const CaterPass = () => {
  const {
    register,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext();
  const [eventApplicationCatersId, setCaterApplicationId] = useState(
    getValues("caterApplicationFormData.id")
  );
  const loginUser = AuthService.getLoginUser();
  const [caterApplicationFormData, setCaterApplicationData] = useState(
    CaterApplicationFormModel
  );

  const getCaterFormDetails = async () => {
    try {
      const res = await EventApplicationService.getCaterApplicationById(
        eventApplicationCatersId
      );
      if (res?.isSuccess) {
        const caterApplicationFormMappedData = {
          ...caterApplicationFormData,
          ...res?.data,
        };
        setValue("caterApplicationFormData", caterApplicationFormMappedData);
      } else {
        // setCaterInitialValue();
        setValue("caterApplicationFormData", caterApplicationFormData);
      }
    } catch (error) {
      //setIsProfileAvailable(false);
      // setCaterInitialValue();
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
      // setCaterInitialValue();
      setValue("caterApplicationFormData", caterApplicationFormData);
    }
  };

  useEffect(() => {
    getCaterFormDetails();
  }, []);

  return (
    <React.Fragment>
      <div className="row">
        <h3>Passes</h3>
        <p className="mt-3 ms-3">
          <li>
            Under no circumstances may allocated passes be transferred or sold
            to third parties
          </li>
          <li>Car passes must be displayed at all times</li>
          <li>Wristbands must be worn at all times</li>
        </p>

        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            <Form.Group controlId="staffBuildWristband">
              <Form.Label>Staff build up and breakdown wristband</Form.Label>
              <Form.Control
                className="effect-4"
                maxLength={15}
                type="text"
                {...register("caterApplicationFormData.staffBuildWristband", {
                  pattern: {
                    value: /^[+]?[0-9]*\.?[0-9]+$/,
                    message: "Please enter a valid number greater than zero.",
                  },
                })}
                defaultValue={caterApplicationFormData?.staffBuildWristband}
              />
              <span className="focus-border"></span>
            </Form.Group>
          </div>
          {errors.caterApplicationFormData?.staffBuildWristband && (
            <span className="text-danger">
              {errors.caterApplicationFormData?.staffBuildWristband?.message}
            </span>
          )}
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            <Form.Group controlId="siteVehiclePass">
              <Form.Label>
                Site access build up and breakdown vehicle pass
              </Form.Label>
              <Form.Control
                className="effect-4"
                maxLength={15}
                type="text"
                {...register("caterApplicationFormData.siteVehiclePass", {
                  pattern: {
                    value: /^[+]?[0-9]*\.?[0-9]+$/,
                    message: "Please enter a valid number greater than zero.",
                  },
                })}
                defaultValue={caterApplicationFormData?.siteVehiclePass}
              />
              <span className="focus-border"></span>
            </Form.Group>
          </div>
          {errors.caterApplicationFormData?.siteVehiclePass && (
            <span className="text-danger">
              {errors.caterApplicationFormData?.siteVehiclePass?.message}
            </span>
          )}
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            <Form.Group controlId="serviceVehiclePass">
              <Form.Label>Service site access label vehicle pass</Form.Label>
              <Form.Control
                className="effect-4"
                maxLength={15}
                type="text"
                {...register("caterApplicationFormData.serviceVehiclePass", {
                  pattern: {
                    value: /^[+]?[0-9]*\.?[0-9]+$/,
                    message: "Please enter a valid number greater than zero.",
                  },
                })}
                defaultValue={caterApplicationFormData?.serviceVehiclePass}
              />
              <span className="focus-border"></span>
            </Form.Group>
          </div>
          {errors.caterApplicationFormData?.serviceVehiclePass && (
            <span className="text-danger">
              {errors.caterApplicationFormData?.serviceVehiclePass?.message}
            </span>
          )}
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            <Form.Group controlId="mceWristband">
              <Form.Label>Mobile caterer event wristband</Form.Label>
              <Form.Control
                className="effect-4"
                maxLength={15}
                type="text"
                {...register("caterApplicationFormData.mceWristband", {
                  pattern: {
                    value: /^[+]?[0-9]*\.?[0-9]+$/,
                    message: "Please enter a valid number greater than zero.",
                  },
                })}
                defaultValue={caterApplicationFormData?.mceWristband}
              />
              <span className="focus-border"></span>
            </Form.Group>
          </div>
          {errors.caterApplicationFormData?.mceWristband && (
            <span className="text-danger">
              {errors.caterApplicationFormData?.mceWristband?.message}
            </span>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default CaterPass;
